import FilterMenu from "@pathwright/ux/src/components/filter/FilterMenu"
import {
  Filters,
  FiltersFilterOptions
} from "@pathwright/ux/src/components/filter/types"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"
import useIsPWAdminUtilEnabled from "../../pw-admin/useIsPWAdminUtilEnabled"
import { usePathNavigator } from "./PathNavigatorContext"

export const pathNavigatorPathFilters = {
  archived_time: {
    label: "Archived Time",
    icon: "clock",
    type: "date"
  }
} as const satisfies Filters

export type PathNavigatorPathFilters = FiltersFilterOptions<
  typeof pathNavigatorPathFilters
> | null

// Filter for toggling off/on boolean for including archive items in the path navigator.
function PathNavigatorFilterMenu() {
  const { navigatorPathFilters, setNavigatorPathFilters } = usePathNavigator()
  const isPWAdminUtilEnabled = useIsPWAdminUtilEnabled()
  const { me } = usePathwrightContext()
  const isPathwrightStaff = me?.permissions?.has_pathwright_staff_access

  return isPWAdminUtilEnabled && isPathwrightStaff ? (
    <FilterMenu
      filters={pathNavigatorPathFilters}
      value={navigatorPathFilters}
      onChange={setNavigatorPathFilters}
    />
  ) : null
}

export default PathNavigatorFilterMenu
